module.exports = __webpack_public_path__ + "static/media/banner-clients-01-mobile.2ab24dc9.jpg";